import { Cookies } from "../helpers";
const nav = (history, to) => {
  const user = Cookies.get("user");
  if (user) {
    history.push(to);
  } else {
    history.push(`/login-registration/1?redirect=${to}`);
  }
};
export const NotificationMapping = (history, payload) => {
  if (!payload) return;
  switch (payload.typeId) {
    case "1":
      nav(history, `/account/bets?open=spin?id=${payload.id}`);
      if (window.location.pathname.includes("account"))
        window.location.reload();
      break;
    case "2":
      nav(history, `/account/notification/single?read=${payload.id}`);
      break;
    case "4":
      if (payload.gameId) {
        nav(history, `/slots/game/${payload.gameId}`);
      } else if (payload.groupId) {
        if (window.location.pathname == `/slots`) {
          history.push(`/slots/${payload.groupId}`);
          window.location.reload();
        } else {
          history.push(`/slots/${payload.groupId}`);
        }
      } else {
        history.push("/slots");
      }
      break;
    case "5":
      if (payload.promoId) {
        history.push(`/promos/${payload.promoId}`);
      } else {
        history.push(`/promos`);
      }
      break;
    case "6":
      if (payload.betCode) {
        if (window.location.pathname == `/sport/6/1/Soccer`) {
          history.push(`/sport/6/1/Soccer?betCode=${payload.betCode}`);
          window.location.reload();
        } else {
          history.push(`/sport/6/1/Soccer?betCode=${payload.betCode}`);
        }
      }
      break;
    case "7":
      if (payload.pageName) {
        history.push(`/document/${payload.pageName}`);
      }
      break;
    case "8":
      nav(history, `/account/bets`);
      break;
    case "9":
      nav(history, `/account`);
      break;
    case "10":
      nav(history, `/account/personal-details`);
      break;
    case "11":
      nav(history, `/account/deposit`);
      break;
    case "12":
      nav(history, `/account/withdraw`);
      break;
    case "13":
      nav(history, `/account/transactions`);
      break;
    case "15":
      nav(history, `/account/add-provider`);
      break;
    case "16":
      nav(history, `/account/customer-service`);
      break;
    case "17":
      // single match notification
      if (payload.urlRoute) {
        history.push(`${payload.urlRoute}`);
        window.location.reload();
      }
      break;
    case "18":
      // home page
      if (payload.urlRoute) {
        history.push(`${payload.urlRoute}`);
      }
      break;
    case "19":
      // reward page
      nav(history, `/account/rewards`);
      break;
    case "20":
      // reward transaction
      nav(history, `/account/rewards/transactions`);
      break;
    case "21":
      // reward item
      if (payload.isGame == "1") {
        nav(
          history,
          `/account/rewards/single-reward/${payload.itemId}/${
            payload.conditionId
          }/1`
        );
      } else {
        nav(
          history,
          `/account/rewards/single-reward/${payload.itemId}/${
            payload.conditionId
          }/0`
        );
      }
      break;
    default:
      break;
  }
};
